// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__c2KH8","hidden":"layout_hidden__3S18S"};